import { StatusChip } from '@/components/ui/info-grid'
import { useModal } from '@/contexts/modal'
import { SignedDocumentModalProps } from '@/modals/InvoiceModals/SignedDocument'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'vnetwork-ui'
import { INVOICE_TYPES, SIGNED_DOCUMENT_STATUS } from '../../constants'
import { SIGNED_DOCUMENTS } from '../../constants/signed-documents'
import { useSignedDocumentErrorText } from '../../hooks/use-signed-document-error-text'
import { GetInvoicesRow, SignedDocumentType } from '../../types'
import { formatDocumentTime } from '../../utils/signed-document'

interface SignedDocumentStatusCellProps {
    row: GetInvoicesRow
    documentType: SignedDocumentType
}

/**
 * Ô trạng thái chứng từ ký số ở danh sách hoá đơn (cột "Đề nghị TT" / "Biên bản").
 * Bấm chip mở popup chứng từ (đã ký thì xem / tải PDF, lỗi thì gửi lại).
 */
const SignedDocumentStatusCell = ({
    row,
    documentType,
}: SignedDocumentStatusCellProps) => {
    const { t } = useTranslation('invoice')
    const errorText = useSignedDocumentErrorText(documentType)
    const { setModal } = useModal()
    const config = SIGNED_DOCUMENTS[documentType]

    const status = row[config.statusField]
    // `cancelled` (ký lại chưa tạo được bản mới) hiện như chưa gửi
    if (
        !status ||
        status === 'cancelled' ||
        row.invoice_type === INVOICE_TYPES.Deposit
    ) {
        return <span className="text-gray-400">-</span>
    }

    const signedAt = row[config.signedAtField]
    const error = row[config.errorField]
    let tooltip = ''
    if (status === 'signed' && signedAt) {
        tooltip = t('signed-document-signed-done-at', {
            time: formatDocumentTime(signedAt),
        })
    } else if (status === 'failed' && error) {
        tooltip = errorText(error)
    }

    const chip = (
        <button
            type="button"
            className="cursor-pointer"
            onClick={(event) => {
                // Không kích hoạt click của dòng
                event.stopPropagation()
                setModal<SignedDocumentModalProps>(
                    'InvoiceModals/SignedDocument/index',
                    {
                        documentType,
                        invoiceID: row.invoice_id,
                        invoiceStatus: row.invoice_status,
                    }
                )
            }}
        >
            <StatusChip value={status} options={SIGNED_DOCUMENT_STATUS(t)} />
        </button>
    )

    return tooltip ? <Tooltip title={tooltip}>{chip}</Tooltip> : chip
}

export default SignedDocumentStatusCell
